<template>
  <div id="input-tag-container" @mouseenter="e => mouse = true" @mouseleave="e => mouse = false">
    <input
      ref="comment-input"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      :style="inputStyle"
      v-model="content"
      @focus="e => focus = true"
      @blur="e => focus = false"
      @keydown.up.prevent.stop="e => moveTagIndex('up')"
      @keydown.down.prevent.stop="e => moveTagIndex('down')"
      @keypress.enter.prevent.stop="e => (filtedTags || []).length === 0 ? $emit('send', content) : commentTag()"
      @input="e => commentOnInput(true)"
      @change="e => $emit('change', content)"
    >
    <div class="input-tag" :style="tagWidth ? { 'min-width': tagWidth } : {}" v-if="(filtedTags.length > 1 || (filtedTags.length && ![content].includes(replace(filtedTags[0])))) && !onCompelete && display && (content || emptyDisplay)">
      <div ref="tag-block" class="tag-block" :style="tagHeight ? { 'max-height': tagHeight } : {}">
        <div class="tag" v-for="(tag, index) in filtedTags" :key="index" :class="{ selected: tagIndex === index }" @mousemove="e => tagIndex = index" @click="commentTag()">{{ tagDisplay(tag) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    init: {
      type: String,
      default: () => ''
    },
    tags: {
      type: Array,
      required: true
    },
    tagWidth: {
      type: String,
      default: () => ''
    },
    tagHeight: {
      type: String,
      default: () => ''
    },
    emptyDisplay: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    prefix: {
      type: String,
      default: () => '(?: |^)'
    },
    target: {
      type: String,
      default: () => '@(?!.* )(.*?)$'
    },
    replace: {
      type: Function,
      default: x => '@' + x + ' '
    },
    filter: {
      type: Function,
      default: () => null
    },
    tagDisplay: {
      type: Function,
      default: x => x
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    // style
    inputStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      content: '',
      keyword: null,
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    }
  },
  computed: {
    filtedTags () {
      if (this.keyword || !this.emptyDisplay) {
        let filter = this.filter(this.keyword) || (x => x.includes(this.keyword))
        return this.tags.filter(x => filter(x))
      } else {
        return this.tags
      }
    }
  },
  watch: {
    'init' () {
      if (this.content !== this.init) {
        this.content = this.init
      }
    },
    'focus' () {
      this.display = this.focus || this.mouse
    }
  },
  created () {
    if (this.content !== this.init) {
      this.content = this.init
    }
  },
  methods: {
    commentOnInput (compelete) {
      compelete && (this.onCompelete = false)
      this.tagIndex = 0
      let match = this.content.match(new RegExp(this.prefix + this.target))
      this.keyword = match ? match[1] : null
      this.$emit('input', this.content)
    },
    moveTagIndex (type) {
      switch (type) {
        case 'up': {
          this.tagIndex = (this.tagIndex - -this.filtedTags.length - 1) % this.filtedTags.length
          break
        }
        case 'down': {
          this.tagIndex = (this.tagIndex - -1) % this.filtedTags.length
          break
        }
      }
      this.$refs['tag-block'].scrollTop = 29.2 * this.tagIndex
    },
    commentTag () {
      const curTag = this.filtedTags[this.tagIndex]
      this.onCompelete = true
      this.content = this.content.replace(new RegExp(this.target), this.replace(curTag))
      this.$emit('tag', curTag)
      this.commentOnInput(this.content)
      this.$refs['comment-input'].focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#input-tag-container
  position: relative
  input
    width: 100%
  .input-tag
    position: absolute
    width: 100%
    top: 33px
    overflow: hidden
    z-index: 10
    .tag-block
      width: 100%
      box-sizing: border-box
      padding: 5px 0
      background: white
      border: 1px solid #595959
      border-radius: 5px
      z-index: 100
      max-height: 400px
      overflow-y: auto
      .tag
        padding: 5px 8px
        font-weight: bold
        cursor: pointer
        user-select: none
        &.selected
          background: steelblue
          color: white
</style>



// WEBPACK FOOTER //
// src/components/tool/inputTag.vue